import { useState, useEffect } from 'react';
import { AgGridReact, AgGridColumn } from 'ag-grid-react';
import styled from 'styled-components';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import moment from 'moment'

// Cell Renderers
import Conditions from './CellRenderers/Conditions';
import Checkbox from '../StudyList/CellRenderers/Checkbox';
import StudyLink from './CellRenderers/StudyLink';
import CTGStudy from '../StudyList/CellRenderers/CTGStudy';
import OverrideField from '../../helpers/OverrideField';
import { getStudy, getCTGStudies } from '../../api/studyListApi';
import LoadRowsComponent from '../../helpers/LoadRowsComponent';
import TotalRow from '../../components/Grid/CellRenderer/TotalRow';
// Tool Panel 
import Presets from '../../components/Grid/Presets/Presets';
import { excelStyles } from '../../components/Grid/ExcelStyles/excelStyles';
import { LicenseManager } from 'ag-grid-enterprise';
LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID);

const CTGListGrid = ({
  studyList,
  search,
  triggerExport,
  setTriggerExport,
  refresh,
  setRefresh,
  sort = "",
  setSort = () => {},
}) => {
  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    if(refresh){
      let refreshOptions = {}
      // if adding the first row, purge for item to properly refresh
      if (gridApi.getDisplayedRowCount() === 0) refreshOptions = { purge: true };
      gridApi.refreshServerSideStore(refreshOptions);
      
      setRefresh(false);
    }
  }, [refresh]);

  useEffect(() => {
    if(gridApi){
      //loads in more rows while scrolling
      const dataSource = {
        getRows: function(params) {
          let sortParam = "";
          if(params.request.sortModel.length !== 0){
            const sortColumn = params.request.sortModel[0].colId;
            const sortWay = params.request.sortModel[0].sort;
            if(sortWay === "desc"){
              sortParam += "-";
            }
          sortParam += sortColumn;
          sortParam = sortParam.replaceAll(".", "__");
          }
          if(sortParam){
            setSort(sortParam);
          }
          else{
            setSort("");
          }
          // const rows = getStudyList({limit: 100, offset: params?.request.startRow, search: search, sort: sortParam})
          const rows = getCTGStudies({size: 100, offset: params?.request.startRow, search: search})
            .then( res => {
              // console.log('res', res)
              setTotalRows(res.hits.total.value);
              gridApi.totalRows = totalRows;
              // console.log(res.hits.hits.map((element) => element._source))
              params.success({
                rowData: res.hits.hits.map((element) => element._source),
                rowCount: res.hits.total.value
              })
              if(res.count === 0){
                gridApi.showNoRowsOverlay();
              }
            });
        }
      };
      gridApi.setServerSideDatasource(dataSource);
    }
  }, [gridApi, search, sort]);

  useEffect(() => {
    if(triggerExport === true) {
      onBtnExport()
      setTriggerExport(false);
    }
  }, [triggerExport])

  const gridOptions = {
    columnDefs: [
      // {
      //   headerName: 'Visible',
      //   field: 'published',
      //   width: 60,
      //   cellRenderer: "checkbox",
      //   cellRendererParams: {
      //     source: "published",
      //   },
      // },
      // {
      //   headerName: 'Featured',
      //   field: 'featured',
      //   width: 60,
      //   cellRenderer: "checkbox",
      //   cellRendererParams: {
      //     source: "featured",
      //   },
      // },
      // {
      //   headerName: 'CTG Study',
      //   field: 'ctg_data',
      //   cellRenderer: 'isCTGStudy',
      //   width: 40,
      // },
      {
        headerName: 'Org ID',
        field: 'ctg_data.org_study_id',
        cellRenderer: "studyLink",
        flex: '1'
      },
     
      {
        headerName: 'Conditions',
        field: "ctg_data.conditions",
        cellRenderer: "conditions",
        flex: '1'
      },
      // {
      //   headerName: 'Brief Title',
      //   field: 'connex_data.brief_title',
      //   cellRenderer: "overrideField",
      //   cellRendererParams: {
      //     source: "brief_title",
      //   },
      //   flex: '1'
      // },
      {
        headerName: 'NCT ID ',
        field: 'ctg_data.id_info.nct_id',
        cellRenderer: "overrideField",
        cellRendererParams: {
          source: "nct_id",
        },
        flex: '1'
      },
      // {
      //   headerName: 'Recruitment Status',
      //   field: 'connex_data.overall_status',
      //   cellRenderer: "overrideField",
      //   cellRendererParams: {
      //     source: "overall_status",
      //   },
      //   flex: '1'
      // },
      {
        headerName: 'Updated at',
        cellRenderer: "updatedTime",
        field: "updated_at",
        flex: '1'
      }
    ],
    defaultColDef: {
      resizable: true,
      sortable: true,
      wrapText: true,
      filter: true,
      enablePivot: true,
      enableCharts: false,
      enableRowGroup: true,
      filterParams: {
        clearButton: true
      },
      cellStyle: { "white-space": "normal !important" },
      autoHeight: true,
      cellClassRules: {
        oddBackground: function (params) {
          return params.rowIndex % 2 == 0;
        },
      },
    },
    icons: {
      list: '<i className="fal fa-list"></i>'
    },
    columnTypes:{
      date: {
        filter: 'agDateColumnFilter',
        filterParams: {
          resetButton: true,
          comparator: function(filterLocalDateAtMidnight, cellValue) {
            let cellDate = null;
            let dateAsString = "";
            dateAsString = cellValue;
            if (dateAsString === null) {
              return 0;
            }
            cellDate = moment(dateAsString).toDate();
            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            } else if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            } else {
              return 0;
            }
          }
        }
      }
    },
    excelStyles,
    frameworkComponents: {
      checkbox: Checkbox,
      conditions: Conditions,
      studyLink: StudyLink,
      overrideField: OverrideField,
      LoadRowsComponent: LoadRowsComponent,
      isCTGStudy: CTGStudy,
      updatedTime: ({ data }) => {
        const updated_at = data?.updated_at;
        return (
          <span>{ updated_at && moment(updated_at).format("DD-MMM-YYYY, HH:mm")}</span>
        );
      },  
    },
    loadingCellRenderer: 'LoadRowsComponent',
    loadingCellRendererParams :{
      loadingMessage: 'One moment please...',
    },
  }

  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  }

  const onBtnExport = () => {
    const params = {
      fileName: "study_list",
      columnKeys: [
        "study_id",
        "sites_count",
        "nct_id"
      ],
      headerRowHeight: 25,
      rowHeight: 20,
    }
    gridApi.exportDataAsExcel(params)
  };

  return (
    <Container className="ag-theme-balham">
      <AgGridReact
        onGridReady={onGridReady}
        gridOptions={gridOptions}
        rowModelType={'serverSide'}
        serverSideStoreType={'partial'}
        cacheBlockSize={100}
      >
      </AgGridReact>
      <TotalRow count={totalRows} />
    </Container>
  );
};

export default CTGListGrid;

const Container = styled.div`
  width: 100%;
  height: 100%;
  padding-bottom: 2em;
`